<template>
    <span style="text-align=center"><slot name="online-text"></slot></span>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "online-grid",
});
</script>

<style scoped></style>